<template>
  <div v-if="Object.keys(data).length > 0" class="border border-zt-light rounded-zt text-xs flex flex-col">
    <div class="border-b border-zt-light flex flex-col bg-zt-light-full p-2.5 font-medium">
      <span class="uppercase">
        Na tym samym etapie rozgrywek w zeszłym sezonie
      </span>
      <span class="text-zt-more text-[10px]">
        Nie uwzględnia ewentualnych punktów ujemnych (kar)
      </span>
    </div>
    <div class="flex justify-between pl-2.5 py-[6px] items-center bg-zt-light-full border-b border-zt-light">
      <span class="leading-[16.5px] uppercase">{{ teamName }}</span>
      <div class="flex items-center">
        <div v-for="column in columns" class="w-[37px] h-full grid place-items-center">
          {{ column }}
        </div>
      </div>
    </div>
    <div class="flex justify-between pl-2.5 py-[9px] border-b border-zt-light items-center text-[13px] bg-[#283344]">
      <span>{{ data.last_season.season }}/{{ data.last_season.season + 1 }}</span>
      <div class="flex items-center font-['Lato']">
        <div class="w-[37px] h-full grid place-items-center">
          {{ data.no_of_matches }}
        </div>
        <div class="w-[37px] h-full grid place-items-center">
          {{ data.last_season.BZ }}
        </div>
        <div class="w-[37px] h-full grid place-items-center">
          {{ data.last_season.BS }}
        </div>
        <div class="w-[37px] h-full grid place-items-center">
          {{ +data.last_season.RB > 0 ? '+' : '' }}{{ data.last_season.RB }}
        </div>
        <div class="w-[37px] h-full grid place-items-center">
          {{ data.last_season.PKT }}
        </div>
      </div>
    </div>
    <div class="flex justify-between pl-2.5 py-[9px] border-b border-zt-light items-center text-[13px] bg-[#283344]">
      <span>{{ data.current_season.season }}/{{ data.current_season.season + 1 }}</span>
      <div class="flex items-center font-['Lato']">
        <div class="w-[37px] h-full grid place-items-center">
          {{ data.no_of_matches }}
        </div>
        <div class="w-[37px] h-full grid place-items-center">
          {{ data.current_season.BZ }}
        </div>
        <div class="w-[37px] h-full grid place-items-center">
          {{ data.current_season.BS }}
        </div>
        <div class="w-[37px] h-full grid place-items-center">
          {{ +data.current_season.RB > 0 ? '+' : '' }}{{ data.current_season.RB }}
        </div>
        <div class="w-[37px] h-full grid place-items-center">
          {{ data.current_season.PKT }}
        </div>
      </div>
    </div>
    <div class="flex justify-between pl-2.5 py-[9px] items-center text-[13px] bg-[#283344]">
      <span>Różnice</span>
      <div class="flex items-center font-['Lato']">
        <div class="w-[37px] h-full grid place-items-center"></div>
        <div :class="{ 'text-green' : diffBZ > 0, 'text-red' : diffBZ < 0 }"
             class="w-[37px] h-full grid place-items-center">
          {{ diffBZ > 0 ? '+' : '' }}{{ diffBZ }}
        </div>
        <div :class="{ 'text-green' : diffBS < 0, 'text-red' : diffBS > 0 }"
             class="w-[37px] h-full grid place-items-center">
          {{ diffBS > 0 ? '+' : '' }}{{ diffBS }}
        </div>
        <div :class="{ 'text-green' : diffRB > 0, 'text-red' : diffRB < 0 }"
             class="w-[37px] h-full grid place-items-center">
          {{ diffRB > 0 ? '+' : '' }}{{ diffRB }}
        </div>
        <div :class="{ 'text-green' : diffPKT > 0, 'text-red' : diffPKT < 0 }"
             class="w-[37px] h-full grid place-items-center">
          {{ diffPKT > 0 ? '+' : '' }}{{ diffPKT }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamCompareWithLastSeason',
  inject: ['WP'],
  props: {
    teamId: {
      type: Number,
      required: true,
    },
    teamName: {
      type: String,
      required: true,
    },
    teamLeagueId: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      columns: ['M', 'BZ', 'BS', 'RB', 'PKT'],
      data: {},
    }
  },
  mounted() {
    this.getTeamLastSeasonComparison();
  },
  computed: {
    diffBZ() {
      if (Object.keys(this.data).length === 0) {
        return 0;
      }
      return +this.data.current_season.BZ - +this.data.last_season.BZ;
    },
    diffBS() {
      if (Object.keys(this.data).length === 0) {
        return 0;
      }
      return +this.data.current_season.BS - +this.data.last_season.BS;
    },
    diffRB() {
      if (Object.keys(this.data).length === 0) {
        return 0;
      }
      return +this.data.current_season.RB - +this.data.last_season.RB;
    },
    diffPKT() {
      if (Object.keys(this.data).length === 0) {
        return 0;
      }
      return +this.data.current_season.PKT - +this.data.last_season.PKT;
    }
  },
  methods: {
    getTeamLastSeasonComparison() {
      axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_team_last_season_comparison',
        team_id: this.teamId,
        league_id: this.teamLeagueId,
      }).then(response => {
        if (typeof response.data.data === 'object') {
          this.data = response.data.data;
        }
      })
    }
  }
}
</script>
<style scoped>
.text-green {
  @apply text-zt-green;
}

.text-red {
  @apply text-zt-red;
}
</style>